export const initialOrganizationData = {
	data: [],
	currentPage: 1,
	pageSize: 10,
	totalCount: 0,
	totalPages: 0,
};

export const initialAttendeeContributionsData = {
	totalPrice: 0,
	totalPaid: 0,
	isCoverFee: false,
	contributions: [],
};

export const initialOrganizationAttentionList = {
	data: [],
};

export const initialReportData = {
	...initialOrganizationData,
	columns: [],
};
